<template>
    <!-- Adım 3: Hesapla ve Düzenle. İki görünüm modu: "Özet" (karar sütunları + satır şelalesi) ve
         "Tüm sütunlar" (İK'nın Excel düzeni). Tasarım: claude.ai/artifact/85Bw2aMArbf95DF7CgfJn5 -->
    <div>
        <b-modal id="dds-edit" size="xl" :title="editTitle" scrollable no-close-on-esc no-close-on-backdrop>
            <div class="row" v-if="editRow">
                <div class="col-lg-7">
                    <h6 class="text-uppercase small font-weight-bolder mb-1" style="color:#B8430A">Banka 2 kalemleri</h6>
                    <g-calculate-salary-process-edit v-model="edit" :hidden-fields="['TICKET','TRAFIK_CEZA']"></g-calculate-salary-process-edit>

                    <div class="border rounded p-1 mt-1" style="background:rgba(31,70,144,.05)">
                        <h6 class="text-uppercase small font-weight-bolder mb-50 text-primary">Harcırah</h6>
                        <div class="d-flex align-items-end mb-50">
                            <div style="width:120px">
                                <label class="form-label" for="dds-ngunu">Çalışma günü (N)</label>
                                <b-form-input id="dds-ngunu" type="number" min="0" max="31" step="0.5" class="text-right" v-model.number="nGunuValue"></b-form-input>
                            </div>
                            <div class="small ml-1 pb-50">× {{ f(editRow.HarcirahGunluk) }} = <strong>{{ f(nGunuEffective * editRow.HarcirahGunluk) }}</strong></div>
                        </div>
                        <div class="small text-muted mb-50">Puantajdaki N: {{ editRow.NGunu }}<span v-if="nGunuEffective != editRow.NGunu"> · manuel</span></div>
                        <b-form-checkbox v-model="harcirahManual" class="mb-50">Harcırahı manuel gir</b-form-checkbox>
                        <div v-if="harcirahManual">
                            <label class="form-label" for="dds-harcirah">Harcırah (manuel)</label>
                            <v-currency-input id="dds-harcirah" input-class="text-right" :value="harcirahValue" v-on:update-value="v => harcirahValue = v"></v-currency-input>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 mt-1 mt-lg-0">
                    <div class="border rounded p-1 h-100" style="background:#FCFCFD">
                        <h6 class="text-uppercase small font-weight-bolder mb-50">Kaydetmeden önce sonuç</h6>
                        <div v-for="l in previewLines" :key="l.label" class="d-flex justify-content-between py-25 border-bottom" :class="l.bold ? 'font-weight-bolder' : ''">
                            <span>{{ l.label }}</span>
                            <span :class="l.value < 0 ? 'text-danger font-weight-bolder' : ''" style="font-variant-numeric:tabular-nums">{{ f(l.value) }}</span>
                        </div>
                        <b-alert v-if="preview && preview.Uyarilar.length" show variant="danger" class="mt-1 mb-0">
                            <div class="alert-body small">
                                <div v-for="u in preview.Uyarilar" :key="u">{{ u }}</div>
                                <div v-if="maxHarcirah > 0" class="mt-25">Harcırahı en fazla {{ f(maxHarcirah) }} yaparak prim eksisini giderebilirsiniz.</div>
                                <div v-else-if="maxHarcirah === 0" class="mt-25">Harcırahı sıfırlamak da yetmiyor: hakediş SGK maaşını karşılamıyor. G kalemlerini (prim, mesai) kontrol edin.</div>
                            </div>
                        </b-alert>
                        <b-alert v-else-if="preview" show variant="success" class="mt-1 mb-0">
                            <div class="alert-body small">Uyarı kalmadı. Kaydettiğinizde satır yeniden hesaplanır.</div>
                        </b-alert>
                    </div>
                </div>
            </div>
            <template #modal-footer><v-executer :loading="saving" :action="save">Kaydet</v-executer></template>
        </b-modal>

        <b-alert v-if="previewMode && uploadErrors.length" show variant="danger" class="mb-1">
            <div class="alert-body small">
                <div class="font-weight-bolder mb-25">Yüklenen şablonda {{ uploadErrors.length }} satır uygulanamadı:</div>
                <div v-for="e in uploadErrors.slice(0, 10)" :key="e">{{ e }}</div>
                <div v-if="uploadErrors.length > 10">… ve {{ uploadErrors.length - 10 }} satır daha.</div>
            </div>
        </b-alert>

        <!-- Özet -->
        <div class="row">
            <div class="col-6 col-md-3 mb-1" v-for="t in tiles" :key="t.label">
                <b-card no-body class="p-1 mb-0 h-100">
                    <div class="small">{{ t.label }}</div>
                    <div class="h4 mb-0 mt-25 font-weight-bolder" :class="t.cls">{{ t.value }}</div>
                </b-card>
            </div>
        </div>

        <b-card no-body class="mb-1">
            <v-table ref="table"
                     :key="mode"
                     :fields="fields"
                     with-items
                     :items="shownRows"
                     pagination="client"
                     row-slot="out"
                     :settings="false">
                <template #additional-actions>
                    <div class="row align-items-center">
                        <div class="col-md-3 mb-1 mb-md-0">
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text><feather-icon icon="SearchIcon"></feather-icon></b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." aria-label="Personel ara" v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <div class="btn-group" role="group" aria-label="Görünüm">
                                <button type="button" class="btn" :class="mode == 'summary' ? 'btn-primary' : 'btn-outline-primary'" :aria-pressed="mode == 'summary'" v-on:click="setMode('summary')">Özet</button>
                                <button type="button" class="btn" :class="mode == 'full' ? 'btn-primary' : 'btn-outline-primary'" :aria-pressed="mode == 'full'" v-on:click="setMode('full')">Tüm sütunlar</button>
                            </div>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <b-form-checkbox v-model="onlyWarn">Yalnız uyarılı satırlar</b-form-checkbox>
                        </div>
                        <div v-if="previewMode" class="col-md-auto mb-1 mb-md-0">
                            <span class="badge badge-light-warning" style="color:#7a3d06">ÖNİZLEME · kaydedilmedi</span>
                        </div>
                        <div class="col-md-auto ml-auto">
                            <!-- Toplantı 08.10.2026: tablo İK'nın Excel düzeninde indirilir (Banka 2 nihai maaş listesinin yerini alır). -->
                            <button class="btn btn-outline-primary mr-50" :disabled="exporting || rows.length == 0" v-on:click="exportExcel">
                                <b-spinner v-if="exporting" small class="mr-50"></b-spinner>
                                <feather-icon v-else icon="DownloadIcon" class="mr-50"></feather-icon>
                                {{ previewMode ? 'Önizleme Excel’ini İndir' : 'Excel İndir' }}
                            </button>
                            <button class="btn btn-primary" v-on:click="recalcRequested = true; getData()">
                                <feather-icon icon="RefreshCwIcon" class="mr-50"></feather-icon>
                                Yeniden Hesapla
                            </button>
                        </div>
                    </div>
                </template>

                <template #row-out="{ row }">
                    <!-- ÖZET -->
                    <template v-if="mode == 'summary'">
                        <tr :key="row.Id" :class="row.Warnings.length ? 'dds-warn-row' : null">
                            <td class="text-center p-25">
                                <button type="button" class="btn btn-icon btn-flat-secondary" :aria-expanded="openId == row.Id" aria-label="Hesap ayrıntısını aç" v-on:click="openId = openId == row.Id ? null : row.Id">
                                    <feather-icon :icon="openId == row.Id ? 'ChevronDownIcon' : 'ChevronRightIcon'"></feather-icon>
                                </button>
                            </td>
                            <td class="text-nowrap font-weight-bold v-table-column-sticky">
                                <feather-icon v-if="row.Warnings.length" icon="AlertTriangleIcon" class="text-danger mr-25" v-b-tooltip.hover :title="row.Warnings.join(' ')"></feather-icon>
                                {{ row.FullName }}
                            </td>
                            <td class="text-nowrap">{{ row.GarageOrTitle }}</td>
                            <td v-for="c in summaryCells" :key="c" class="text-nowrap text-right" :class="cellClass(row[c], c)">{{ f(row[c]) }}</td>
                            <td class="text-center p-25">
                                <button type="button" class="btn btn-icon btn-flat-secondary" aria-label="Kalemleri düzenle" :disabled="row.Locked || row.Finalized" v-on:click="openEdit(row)"><feather-icon icon="Edit2Icon"></feather-icon></button>
                            </td>
                        </tr>
                        <tr v-if="openId == row.Id" :key="row.Id + '-d'">
                            <td :colspan="summaryCells.length + 4" class="p-0 dds-detail-cell">
                                <div class="row no-gutters p-1 pl-4 dds-detail-box">
                                    <div class="col-md-4 pr-md-2 mb-1 mb-md-0">
                                        <h6 class="text-uppercase small font-weight-bolder" style="color:#B8430A">1 · Banka 2 hakediş</h6>
                                        <dds-line label="Maaş [Baz Fiili] + YİÜ" :value="row.CalismaKazanci + row.YillikIzinKazanc"></dds-line>
                                        <dds-line label="Prim [Toplam]" :value="row.PrimToplam"></dds-line>
                                        <dds-line label="Yemek, yol, mesai, dengeleyici, ODÖ, destek" :value="row.ToplamHakedis - row.CalismaKazanci - row.YillikIzinKazanc - row.PrimToplam"></dds-line>
                                        <dds-line label="Toplam Hakediş" :value="row.ToplamHakedis" bold></dds-line>
                                        <dds-line label="− Banka 2 kesintileri" :value="row.Banka2TrafikCezasi + row.Banka2Vukuat + row.Banka2Avans"></dds-line>
                                        <dds-line :label="`− Harcırah${row.HarcirahElle != null ? ' (manuel)' : ` (${row.NGunuManuel != null ? row.NGunuManuel : row.NGunu} gün${row.NGunuManuel != null ? ' manuel' : ''} × ${f(row.HarcirahGunluk)})`}`" :value="row.Harcirah"></dds-line>
                                        <dds-line label="− Yemek Kart" :value="row.YemekKart"></dds-line>
                                        <dds-line label="SGK Hakediş" :value="row.SgkHakedis" bold></dds-line>
                                    </div>
                                    <div class="col-md-4 px-md-2 border-left mb-1 mb-md-0">
                                        <h6 class="text-uppercase small font-weight-bolder text-primary">2 · Bordro dağılımı</h6>
                                        <dds-line :label="`Maaş (SGK) · ${row.UcreteTabiGun} gün`" :value="row.MaasSgkTl"></dds-line>
                                        <dds-line :label="`FM ${row.FmSaat} sa`" :value="row.FmTl"></dds-line>
                                        <dds-line :label="`HTM ${row.HtmSaat} sa`" :value="row.HtmTl"></dds-line>
                                        <dds-line :label="`GTM ${row.GtmSaat} sa`" :value="row.GtmTl"></dds-line>
                                        <dds-line v-if="row.Afok" label="AFOK" :value="row.Afok"></dds-line>
                                        <dds-line v-if="row.YillikIzinKazanc" label="YİÜ (SGK)" :value="row.YillikIzinKazanc"></dds-line>
                                        <dds-line label="Bordro Prim" :value="row.BordroPrim"></dds-line>
                                        <dds-line label="Prim Mesai" :value="row.PrimMesai"></dds-line>
                                        <dds-line label="= SGK Hakediş" :value="row.SgkHakedis" bold></dds-line>
                                    </div>
                                    <div class="col-md-4 pl-md-2 border-left">
                                        <h6 class="text-uppercase small font-weight-bolder text-success">3 · Ödemeler</h6>
                                        <dds-line label="− Avans" :value="row.Avans"></dds-line>
                                        <dds-line label="− İcra" :value="row.Icra"></dds-line>
                                        <dds-line label="− BES" :value="row.Bes"></dds-line>
                                        <dds-line label="− Kesinti, trafik cezası, belge ile ödenen" :value="row.Kesinti + row.TrafikCezasi + row.BelgeIleOdenen"></dds-line>
                                        <dds-line label="Ödeme [Banka 1]" :value="row.Banka1Odeme" bold></dds-line>
                                        <dds-line label="Harcırah dosyası" :value="row.Harcirah"></dds-line>
                                        <dds-line label="Yemek kartı" :value="row.YemekKart"></dds-line>
                                        <dds-line label="Ödeme [Banka 2] kontrol" :value="row.Banka2Kontrol"></dds-line>
                                        <b-alert v-if="row.Warnings.length" show variant="danger" class="mt-1 mb-0">
                                            <div class="alert-body small">{{ row.Warnings.join(' ') }} Kalem ekranından (ör. harcırahı düşürerek) düzeltin.</div>
                                        </b-alert>
                                        <div class="small text-muted mt-50" v-if="!row.Finalized">İcra ve BES 4. adımda (Luca bordrosu sonrası) gelir.</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <!-- TÜM SÜTUNLAR -->
                    <tr v-else :key="row.Id" :class="row.Warnings.length ? 'dds-warn-row' : null">
                        <td class="text-nowrap font-weight-bold v-table-column-sticky">
                            <feather-icon v-if="row.Warnings.length" icon="AlertTriangleIcon" class="text-danger mr-25" v-b-tooltip.hover :title="row.Warnings.join(' ')"></feather-icon>
                            {{ row.FullName }}
                        </td>
                        <td class="text-nowrap">{{ row.GarageOrTitle }}</td>
                        <td class="text-nowrap text-right">{{ row.UcreteTabiGun }}</td>
                        <td class="text-nowrap text-right">{{ row.NGunu }}</td>
                        <td v-for="c in fullCells" :key="c" class="text-nowrap text-right" :class="cellClass(row[c], c)">{{ f(row[c]) }}</td>
                        <td class="text-center p-25">
                            <button type="button" class="btn btn-icon btn-flat-secondary" aria-label="Kalemleri düzenle" :disabled="row.Locked || row.Finalized" v-on:click="openEdit(row)"><feather-icon icon="Edit2Icon"></feather-icon></button>
                        </td>
                    </tr>
                </template>
            </v-table>
        </b-card>

        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" :disabled="previewMode" v-on:click="$emit('next')">{{ previewMode ? 'İleri — önizlemede kapalı' : 'İleri' }}</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BModal, BAlert, BInputGroup, BInputGroupText, BFormInput, BFormCheckbox, BSpinner, VBTooltip } from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import GCalculateSalaryProcessEdit from '../../calculate-salary-process-g/components/GCalculateSalaryProcessEdit.vue'
import { calculateDomesticDriverSalary, inputFromRow, maxHarcirahForNonNegativePrim } from '@/utilities/domestic-driver-salary-calc'

const MODE_KEY = 'dds-view-mode'
const fmt = v => Number(v || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
// Kalem penceresi alan adları (GSalary.Update sözleşmesi) ↔ satır modeli alan adları
const EDIT_MAP = {
    MESAI_UCRETI: 'MesaiUcreti', BAYRAM_MESAISI: 'BayramMesaisi', YEMEK_UCRETI: 'YemekUcreti', YOL_UCRETI: 'YolUcreti',
    PRIM: 'Prim', DESTEK_PRIMI: 'DestekPrimi', MAZOT_PRIMI: 'MazotPrimi', HAMMALIYE_BEDELI: 'HammaliyeBedeli',
    YATMA: 'Yatma', SIFIRLAMA: 'Sifirlama', DIGER: 'Diger'
}
// Uyarı verilecek hesaplanmış sütunlar (girdi sütunlarındaki eksiler — ör. Prim [Yakıt] −700 — uyarı değildir).
const WARN_COLS = ['SgkHakedis', 'ToplamPrim', 'BordroPrim', 'PrimMesai', 'Banka1Odeme']

const DdsLine = {
    props: { label: String, value: Number, bold: Boolean },
    render(h) {
        return h('div', { class: ['d-flex justify-content-between py-25', this.bold ? 'font-weight-bolder border-top mt-25 pt-50' : ''] }, [
            h('span', this.label),
            h('span', { class: this.value < 0 ? 'text-danger font-weight-bolder' : '', style: 'font-variant-numeric:tabular-nums' }, fmt(this.value))
        ])
    }
}

export default {
    components: { BCard, BModal, BAlert, BInputGroup, BInputGroupText, BFormInput, BFormCheckbox, BSpinner, VCurrencyInput, GCalculateSalaryProcessEdit, DdsLine },
    directives: { 'b-tooltip': VBTooltip },
    props: {
        donem: { type: Object, default: () => ({ year: null, month: null }) },
        filter: { type: Object, default: () => ({}) },
        previewMode: { type: Boolean, default: false },
        previewFile: { type: [File, Object], default: null }
    },
    data() {
        let mode = 'summary'
        try { mode = window.localStorage.getItem(MODE_KEY) || 'summary' } catch (e) { /* tarayıcı depolaması kapalıysa varsayılan */ }
        return {
            mode,
            rows: [],
            searchValue: '',
            onlyWarn: false,
            openId: null,
            editRow: null,
            edit: {},
            harcirahManual: false,
            harcirahValue: null,
            nGunuValue: null,
            saving: false,
            exporting: false,
            previewExcelPath: null,
            uploadErrors: [],
            recalcRequested: false,
            summaryCells: ['ToplamHakedis', 'SgkHakedis', 'BordroPrim', 'Banka1Odeme', 'Harcirah', 'YemekKart', 'Banka2Kontrol'],
            fullCells: ['PrimToplam', 'YemekUcreti', 'ToplamHakedis',
                'Banka2TrafikCezasi', 'Banka2Vukuat', 'Banka2Avans', 'KalanHakedis',
                'Harcirah', 'YemekKart', 'SgkHakedis',
                'MaasSgkTl', 'FmTl', 'HtmTl', 'GtmTl', 'Afok', 'YillikIzinKazanc', 'ToplamPrim', 'BordroPrim', 'PrimMesai',
                'Avans', 'Icra', 'Bes', 'Kesinti', 'TrafikCezasi', 'BelgeIleOdenen',
                'Banka1Odeme', 'Banka2Kontrol']
        }
    },
    mounted() {
        this.getData()
    },
    computed: {
        shownRows() {
            let rows = this.onlyWarn ? this.rows.filter(r => r.Warnings.length) : this.rows
            // Önizlemede satırlar bir kez hesaplanır; arama ekranda süzülür.
            const q = this.previewMode ? (this.searchValue || '').trim().toLocaleLowerCase('tr-TR') : ''
            if (q) rows = rows.filter(r => (r.FullName || '').toLocaleLowerCase('tr-TR').includes(q))
            return rows
        },
        fields() {
            const r = (name, tooltip) => ({ name, tdClass: 'text-right', thClass: 'vt-th-text-right', tooltip })
            if (this.mode == 'summary') {
                return [
                    { name: '' },
                    { name: 'Adı Soyadı', sticky: true },
                    { name: 'Unvan' },
                    r('Toplam Hakediş'), r('SGK Hakediş', 'Toplam Hakediş − Banka 2 kesintileri − Harcırah − Yemek Kart'),
                    r('Bordro Prim'), r('Ödeme [Banka 1]'), r('Harcırah'), r('Yemek Kart'), r('Banka 2', 'Herkeste 0 olmalı.'),
                    { name: '' }
                ]
            }
            return [
                { name: '', children: [{ name: 'Adı Soyadı', sticky: true }, { name: 'Unvan' }, r('ÜTGS'), r('N')] },
                { name: 'Banka 2 · Hakediş', thClass: 'bg-light-secondary', children: [r('Prim [Toplam]'), r('Yemek'), r('Toplam Hakediş')] },
                { name: 'Banka 2 · Kesinti', thClass: 'bg-light-danger', children: [r('Trafik Cezası'), r('Vukuat'), r('Avans'), r('Kalan Hakediş')] },
                { name: 'SGK Hakediş', thClass: 'bg-light-primary', children: [r('Harcırah'), r('Yemek Kart'), r('SGK Hakediş')] },
                { name: 'Bordro dağılımı', thClass: 'bg-light-primary', children: [r('Maaş'), r('FM'), r('HTM'), r('GTM'), r('AFOK'), r('YİÜ (SGK)'),
                    r('Toplam Prim', 'SGK Hakediş − Maaş − FM − HTM − GTM − AFOK − YİÜ (SGK)'), r('Bordro Prim'), r('Prim Mesai')] },
                { name: 'Banka 1 · Kesinti', thClass: 'bg-light-info', children: [r('Avans'), r('İcra'), r('BES'), r('Kesinti'), r('Trafik Cezası'), r('Belge ile Ödenen')] },
                { name: 'Ödemeler', thClass: 'bg-light-success', children: [r('Banka 1'), r('Banka 2', 'Herkeste 0 olmalı.')] },
                { name: '', children: [{ name: '' }] }
            ]
        },
        tiles() {
            const sum = k => fmt(this.rows.reduce((a, r) => a + (r[k] || 0), 0)) + ' ₺'
            const warn = this.rows.filter(r => r.Warnings.length).length
            return [
                { label: 'Personel', value: this.rows.length },
                { label: 'Uyarılı satır', value: warn, cls: warn ? 'text-danger' : 'text-success' },
                { label: 'Toplam Ödeme [Banka 1]', value: sum('Banka1Odeme') },
                { label: 'Toplam Harcırah', value: sum('Harcirah') }
            ]
        },
        editTitle() {
            return this.editRow ? `Düzenle · ${this.editRow.FullName}` : 'Düzenle'
        },
        previewEdits() {
            if (!this.editRow) return null
            const e = {}
            Object.keys(EDIT_MAP).forEach(k => { e[EDIT_MAP[k]] = Number(this.edit[k] || 0) })
            e.HarcirahElle = this.harcirahManual ? Number(this.harcirahValue || 0) : null
            // Puantajla aynı N manuel sayılmaz (sunucu da aynı kuralı uygular).
            e.NGunuManuel = this.nGunuEffective != this.editRow.NGunu ? this.nGunuEffective : null
            return e
        },
        nGunuEffective() {
            const v = Number(this.nGunuValue)
            return this.nGunuValue === '' || this.nGunuValue == null || isNaN(v) ? (this.editRow?.NGunu ?? 0) : v
        },
        preview() {
            if (!this.editRow) return null
            return calculateDomesticDriverSalary(inputFromRow(this.editRow, this.previewEdits))
        },
        previewLines() {
            const p = this.preview
            if (!p) return []
            const toplam = inputFromRow(this.editRow, this.previewEdits).ToplamHakedis
            return [
                { label: 'Toplam Hakediş', value: toplam },
                { label: '− Banka 2 kesintileri', value: this.editRow.Banka2TrafikCezasi + this.editRow.Banka2Vukuat + this.editRow.Banka2Avans },
                { label: '− Harcırah', value: p.Harcirah },
                { label: '− Yemek Kart', value: this.previewEdits.YemekUcreti },
                { label: 'SGK Hakediş', value: p.SgkHakedis, bold: true },
                { label: 'Maaş (SGK)', value: p.MaasSgkTl },
                { label: 'FM · HTM · GTM', value: p.FmTl + p.HtmTl + p.GtmTl },
                { label: 'AFOK · YİÜ (SGK)', value: p.Afok + p.YillikIzinSgk },
                { label: 'Toplam Prim', value: p.ToplamPrim },
                { label: 'Bordro Prim', value: p.BordroPrim },
                { label: 'Prim Mesai', value: p.PrimMesai },
                { label: 'Ödeme [Banka 1]', value: p.Banka1Odeme, bold: true },
                { label: 'Ödeme [Banka 2] kontrol', value: p.Banka2Kontrol }
            ]
        },
        // Prim eksisini kapatacak en yüksek harcırah (diğer kalemler sabitken). HTM/GTM bazı Bordro Prim'e bağlı
        // olduğundan "harcırah + Toplam Prim" DEĞİLDİR; Bordro Prim = 0 noktasından hesaplanır.
        maxHarcirah() {
            if (!this.preview || this.preview.ToplamPrim >= 0) return null
            return maxHarcirahForNonNegativePrim(inputFromRow(this.editRow, this.previewEdits))
        }
    },
    methods: {
        f: fmt,
        cellClass(v, col) {
            return v < 0 && WARN_COLS.includes(col) ? 'text-danger font-weight-bolder bg-light-danger' : (col == 'Banka2Kontrol' && v == 0 ? 'text-success' : null)
        },
        setMode(m) {
            this.mode = m
            try { window.localStorage.setItem(MODE_KEY, m) } catch (e) { /* yok sayılır */ }
        },
        exportExcel() {
            if (this.previewMode) {
                if (this.previewExcelPath) Additional.DownloadTab(this.previewExcelPath)
                return
            }
            this.exporting = true
            EmployeeOperationsApi.DomesticDriverSalary.TableExcel({ ...this.filter, PaginateRequest: { QueryParam: '' } }).then(res => {
                this.exporting = false
                if (res.data.Success) Additional.DownloadTab(res.data.Data)
                else this.$result(res)
            }).catch(err => {
                this.exporting = false
                this.$result(null, err)
            })
        },
        async getPreviewData() {
            this.$refs.table?.setLoading(true)
            try {
                const formData = await Additional.ToFormData({
                    EmployeeSalaryGroupId: this.filter.EmployeeSalaryGroupId,
                    Month: this.filter.Month,
                    Year: this.filter.Year,
                    File: this.previewFile
                }, ['File'])
                const res = await EmployeeOperationsApi.DomesticDriverSalary.PreviewTable(formData)
                if (res.data.Success) {
                    this.rows = (res.data.Data.Rows || []).map(r => ({ ...r, Warnings: r.Warnings || [] }))
                    this.previewExcelPath = res.data.Data.ExcelPath
                    this.uploadErrors = res.data.Data.UploadErrors || []
                } else {
                    this.$result(res)
                }
            } catch (err) {
                this.$result(null, err)
            }
            this.$refs.table?.setLoading(false)
        },
        getData() {
            if (this.previewMode) {
                // Arama ekranda süzülür; yeniden hesap (ve ekrandaki düzenlemelerin sıfırlanması) yalnız düğmeyle.
                if (this.rows.length == 0 || this.recalcRequested) this.getPreviewData()
                this.recalcRequested = false
                return
            }
            this.$refs.table?.setLoading(true)
            EmployeeOperationsApi.DomesticDriverSalary.Table({
                ...this.filter,
                PaginateRequest: { QueryParam: this.searchValue }
            }).then(res => {
                if (res.data.Success) {
                    this.rows = (res.data.Data || []).map(r => ({ ...r, Warnings: r.Warnings || [] }))
                } else {
                    this.$result(res)
                }
                this.$refs.table?.setLoading(false)
            }).catch(err => {
                this.$result(null, err)
                this.$refs.table?.setLoading(false)
            })
        },
        openEdit(row) {
            this.editRow = row
            const e = { Id: row.GSalaryPaymentId, DIGERACIKLAMA: row.DigerAciklama, TICKET: row.YemekUcreti, TRAFIK_CEZA: 0 }
            Object.keys(EDIT_MAP).forEach(k => { e[k] = row[EDIT_MAP[k]] })
            this.edit = e
            this.harcirahManual = row.HarcirahElle != null
            this.harcirahValue = row.HarcirahElle
            this.nGunuValue = row.NGunuManuel ?? row.NGunu
            this.$showModal('dds-edit')
        },
        async save(override = false) {
            const row = this.editRow
            const gChanged = Object.keys(EDIT_MAP).some(k => Number(this.edit[k] || 0) != row[EDIT_MAP[k]]) || (this.edit.DIGERACIKLAMA || null) != (row.DigerAciklama || null)
            const newHarc = this.harcirahManual ? Number(this.harcirahValue || 0) : null
            const newN = this.previewEdits.NGunuManuel
            if (this.nGunuEffective < 0 || this.nGunuEffective > 31) { this.$toast.warning('Çalışma günü (N) 0 ile 31 arasında olmalıdır.'); return }
            const hChanged = newHarc != row.HarcirahElle || newN != (row.NGunuManuel ?? null)
            if (!gChanged && !hChanged) { this.$hideModal('dds-edit'); return }
            if (this.previewMode) {
                // Önizleme: sunucuya yazılmaz; satır ekrandaki hesapla güncellenir (icra yeniden hesaplanmaz).
                const edits = this.previewEdits
                const input = inputFromRow(row, edits)
                const res = calculateDomesticDriverSalary(input)
                Object.assign(row, edits, {
                    DigerAciklama: this.edit.DIGERACIKLAMA,
                    ToplamHakedis: input.ToplamHakedis,
                    PrimToplam: edits.Prim + edits.DestekPrimi + edits.MazotPrimi + edits.HammaliyeBedeli + edits.Yatma,
                    YemekKart: edits.YemekUcreti,
                    KalanHakedis: res.KalanHakedis, Harcirah: res.Harcirah, SgkHakedis: res.SgkHakedis,
                    MaasSgkTl: res.MaasSgkTl, FmTl: res.FmTl, HtmTl: res.HtmTl, GtmTl: res.GtmTl,
                    ToplamPrim: res.ToplamPrim, BordroPrim: res.BordroPrim, PrimMesai: res.PrimMesai,
                    Banka1Odeme: res.Banka1Odeme, Banka2Kontrol: res.Banka2Kontrol,
                    Warnings: res.Uyarilar
                })
                this.$hideModal('dds-edit')
                return
            }
            this.saving = true
            try {
                if (gChanged) {
                    const data = { ...this.edit, TICKET: Number(this.edit.YEMEK_UCRETI || 0), Override: override }
                    Object.keys(EDIT_MAP).forEach(k => { data[k] = Number(data[k] || 0) })
                    const res = await EmployeeOperationsApi.GSalary.Update(data)
                    if (!res.data.Success) {
                        this.saving = false
                        if (res.data.Message == 'OVERRIDE_REQUIRED') {
                            const c = await this.$confirm('Düzenlemek istediğinize emin misiniz?', 'Bu kayıt onaylanmış. Devam ederseniz onayı kaldırılır.')
                            if (c) this.save(true)
                        } else this.$result(res)
                        return
                    }
                }
                if (hChanged) {
                    const res = await EmployeeOperationsApi.DomesticDriverSalary.SetHarcirah({ Id: row.Id, Harcirah: newHarc, NGunu: newN, Override: override })
                    if (!res.data.Success) {
                        this.saving = false
                        if (res.data.Message == 'OVERRIDE_REQUIRED') {
                            const c = await this.$confirm('Düzenlemek istediğinize emin misiniz?', 'Bu kayıt onaylanmış. Devam ederseniz onayı kaldırılır.')
                            if (c) this.save(true)
                        } else this.$result(res)
                        return
                    }
                }
                this.$hideModal('dds-edit')
                this.getData()
            } catch (err) {
                this.$result(null, err)
            }
            this.saving = false
        }
    }
}
</script>

<style>
.dds-warn-row td { background-color: rgba(255, 36, 66, .06); }
.dds-detail-cell { background-color: #FBFBFD; }
/* Detay paneli tablonun yatay kaydırmasından bağımsız: görünen alanda solda sabit, genişliği görünen alanı aşmaz. */
.dds-detail-box { position: sticky; left: 0; width: min(1100px, calc(100vw - 420px)); min-width: 640px; white-space: normal; }
.dark-layout .dds-detail-cell { background-color: #283046; }
.dds-warn-row td.v-table-column-sticky { background-color: #FFF4F5; }
.dark-layout .dds-warn-row td.v-table-column-sticky { background-color: #3a2a35; }
</style>
